import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {PROPOSITION_BETS} from "../proposition-bets-widgets.consts";
import {PropositionBetsWidgetMarketShowMoreClickEvent} from "../models/proposition-bets-widget.market-show-more.click-event";

export class PropositionBetsWidgetMarketShowMoreClickEventHandler extends AnalyticsEventHandler {
  type = PROPOSITION_BETS.ANALYTICS.ACTION_TYPES.onShowMoreClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PropositionBetsWidgetMarketShowMoreClickEvent;
  }
}
